// Merge a `source` object to a `target` recursively
export const merge = (target, source) => {
    // Iterate through `source` properties and if an `Object` set property to merge of `target` and `source` properties
    for (const key of Object.keys(source)) {
      if (source[key] instanceof Object) Object.assign(source[key], merge(target[key], source[key]))
    }
    // Join `target` and modified `source`
    Object.assign(target || {}, source)
    return target
}

export const repeat = (times) => ((new Array(times)).fill(true)).map((n, i) => i)

export const toQueryParam = (obj) => Object.keys(obj).map(key => `${key}=${obj[key]}`).join('&')

  